var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuildIconTv = function SvgBuildIconTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#827127",
    fillRule: "evenodd",
    d: "M3.027 0H41.32a3.04 3.04 0 0 1 3.028 3.039v23.554a3.04 3.04 0 0 1-3.028 3.038H23.025v1.19l10.413 2.2c.638.133.435 1.1-.203.966l-11.061-2.335-11.061 2.335c-.638.134-.841-.833-.203-.967l10.413-2.198v-1.19H3.028A3.04 3.04 0 0 1 0 26.592V3.04A3.04 3.04 0 0 1 3.028 0zm.185 1.248h37.921c.741 0 1.346.608 1.346 1.35v24.435c0 .744-.606 1.35-1.346 1.35H3.212c-.74 0-1.346-.607-1.346-1.35V2.599c0-.744.606-1.35 1.346-1.35",
    clipRule: "evenodd"
  })));
};
export default SvgBuildIconTv;